import React from "react";
import { Hidden } from "@material-ui/core";

import DesktopHeader from "./desktop/FunnelTopHeader";
import MobileHeader from "./mobile";

function FunnelHeader({ children, cta, logoHref }) {
  return (
    <>
      <Hidden mdUp implementation="css">
        <MobileHeader cta={cta}>{children}</MobileHeader>
      </Hidden>
      <Hidden implementation="css" smDown>
        <DesktopHeader cta={cta} logoHref={logoHref}>
          {children}
        </DesktopHeader>
      </Hidden>
    </>
  );
}

export default FunnelHeader;
